import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './components/Dashboard';
import VenuesPage from './pages/VenuesPage';
import VenueAllowlistPage from './pages/VenueAllowlistPage';
import VenueGroupingPage from './pages/VenueGroupingPage';
import EventsPage from './pages/EventsPage';
import ArtistsPage from './pages/ArtistsPage';
import IngestionPage from './pages/IngestionPage';
import RegionsPage from './pages/RegionsPage';
import UsagePage from './pages/UsagePage';
import EmailSubscriptionsPage from './pages/EmailSubscriptionsPage';
import CDNPage from './pages/CDNPage';
import ShareActivityPage from './pages/ShareActivityPage';
import VenueViewsAnalyticsPage from './pages/VenueViewsAnalyticsPage';
import CalendarViewsAnalyticsPage from './pages/CalendarViewsAnalyticsPage';
import TicketClicksAnalyticsPage from './pages/TicketClicksAnalyticsPage';
import ApiExplorerPage from './pages/ApiExplorerPage';
import './App.css';

const AppRoutes: React.FC = () => {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={!user ? <Login /> : <Navigate to="/" replace />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/venues"
        element={
          <ProtectedRoute>
            <VenuesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/venues/allowlist"
        element={
          <ProtectedRoute>
            <VenueAllowlistPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/venues/groups"
        element={
          <ProtectedRoute>
            <VenueGroupingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/events"
        element={
          <ProtectedRoute>
            <EventsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/artists"
        element={
          <ProtectedRoute>
            <ArtistsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ingestion"
        element={
          <ProtectedRoute>
            <IngestionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/regions"
        element={
          <ProtectedRoute>
            <RegionsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/usage"
        element={
          <ProtectedRoute>
            <UsagePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/subscriptions"
        element={
          <ProtectedRoute>
            <EmailSubscriptionsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cdn"
        element={
          <ProtectedRoute>
            <CDNPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/share-activity"
        element={
          <ProtectedRoute>
            <ShareActivityPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/venue-views"
        element={
          <ProtectedRoute>
            <VenueViewsAnalyticsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/calendar-views"
        element={
          <ProtectedRoute>
            <CalendarViewsAnalyticsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/ticket-clicks"
        element={
          <ProtectedRoute>
            <TicketClicksAnalyticsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/api-explorer"
        element={
          <ProtectedRoute>
            <ApiExplorerPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;

